export const enum GenericEvents {
	LOGIN_SHOW = 'login_show',
}
